import DepartmentFilter from './Department';
import VehicleTypeFilter from './VehicleType';

export default {
  DepartmentFilter,
  VehicleTypeFilter,
};
